import {Panel} from "primereact/panel";
import {Fieldset} from "primereact/fieldset";
import {Button} from "primereact/button";
import React from "react";

export default function SpotifyConnectionInfo(props) {
    return(
        <Panel header="Information / How To" toggleable collapsed={false}>
            <Fieldset className={"p-0"} legend={"Important"}>
                In order to connect to your own spotify account and save playlists there, you have to:
                <ul>
                    <li>Create an account on laramon (top right, round icon)</li>
                    <li>Have access to a spotify app key (see below)</li>
                    <li>Connect your own account and give access rights to your playlists</li>
                </ul>
            </Fieldset>
            <Fieldset className={"p-0"} legend={"Spotify App Key"}>
                In order to connect to your spotify account, you need to either have a spotify developer account or you need to know someone who has a spotify developer account and is willing to add you to their account.
                <ul>
                    <li>Why dont you implement an easy authorization flow like e.g. weverse or last.fm?</li>
                    <ul>
                        <li>Since this year (2025) spotify no longer grants app keys with unlimited access to small developers. Only companies, with at least 200'000 users and a business model that is of interest to spotify can apply for wider access.</li>
                        <li>As a workaround you can create your own app, but instead of developing your own app, you can run this app with your API keys.</li>
                    </ul>
                    <br/>
                    <li>Is it complicated to get my own app key?</li>
                    Not really, the spotify developer site is very intuitive (more so than this page, at the moment :))
                    <ul>
                        <li>Go to: https://developer.spotify.com/
                            <Button size={"small"} icon="pi pi-external-link" text aria-label="OpenSpotifyDeveloperNewTab" onClick={() => {
                            let win = window.open('https://developer.spotify.com/', '_blank');
                            win.focus();
                        }}/>
                            and login with your spotify account</li>
                        <li>Go to dashboard</li>
                        <li>Create app</li>
                        <li>More info on what to fill in, is in the section below, if you are logged in :)</li>
                    </ul>
                </ul>
            </Fieldset>
            <Fieldset className={"p-0"} legend={"Spotify Users"}>
                You can add 1 or more Spotify Users. If you have created your own app key, add all the e-mail addresses (up to 25) in the User Management part of your spotify app.
            </Fieldset>
        </Panel>
    )
}